<template>
  <div
    v-if="active"
    ref="wrapper"
    :style="{flexDirection: direction, gap, justifyContent, padding, width: w === '100%' ? w : 'unset'}"
    :class="{'absolute left-0 right-0': absolute, 'flex-wrap': wrap}"
    class="z-10 flex items-center"
  >
    <div
      v-for="skeleton in skeletons"
      :key="skeleton"
      :style="{
        width: w,
        height: h,
        borderRadius: br,
        background:
          theme === 'light'
            ? 'linear-gradient(90deg, #afafaf 0%, #e6e6e6 100%)'
            : 'linear-gradient(90deg, rgb(80, 80, 80) 0%, rgb(110, 110, 110) 100%)'
      }"
      class="max-w-desktop bg-[length:400%_400%] animate-pulse duration-200"
    ></div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    name: 't-loader-skeleton',
    props: {
      skeletons: {
        type: Number,
        required: false,
        default: 1
      },
      br: {
        type: String,
        required: false,
        default: '10px'
      },
      w: {
        type: String,
        required: false,
        default: '100%'
      },
      h: {
        type: String,
        required: false,
        default: '228px'
      },
      absolute: {
        type: Boolean,
        required: false,
        default: false
      },
      direction: {
        type: String,
        required: false,
        default: 'column'
      },
      justifyContent: {
        type: String,
        required: false,
        default: 'center'
      },
      gap: {
        type: String,
        required: false,
        default: '16px'
      },
      padding: {
        type: String,
        required: false,
        default: '0'
      },
      wrap: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data() {
      return {
        active: true
      }
    },
    computed: {
      ...mapGetters(['theme'])
    },
    mounted() {
      this.$refs.wrapper.scrollTop = 0
    },
    methods: {
      toggleActive() {
        this.active = !this.active
      }
    }
  }
</script>
